module.exports = __webpack_public_path__ + "img/Berget-21-header-banner.3e02952b.jpg";